var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 55,
    viewBox: "0 0 70 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1480_11889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.147 10.0029H56.365C56.484 10.0479 56.602 10.0979 56.723 10.1379C57.397 10.3589 57.406 10.3879 56.923 10.8729C55.761 12.0383 54.598 13.2029 53.434 14.3669C47.86 19.9556 42.2867 25.5453 36.714 31.136C36.4569 31.4444 36.1157 31.6715 35.732 31.7899C35.3894 31.8739 35.0303 31.8608 34.6947 31.7522C34.3591 31.6436 34.0604 31.4437 33.832 31.1749C27.1254 24.4369 20.4127 17.7036 13.694 10.975C13.094 10.369 13.094 10.369 13.924 10.089C13.999 10.064 14.072 10.0319 14.147 10.0029Z",
    fill: "#FCEFEA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1480_11889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.695 13.4589C10.788 13.2039 10.878 12.948 10.976 12.696C11.066 12.465 11.203 12.396 11.402 12.596C11.481 12.675 11.563 12.752 11.642 12.831L25.589 26.8179C26.037 27.2669 26.037 27.27 25.589 27.718L11.709 41.6369C11.109 42.2369 11.109 42.237 10.832 41.432C10.79 41.312 10.74 41.1939 10.693 41.0749L10.695 13.4589Z",
    fill: "#FCEFEA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1480_11889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.207 44.5599C28.5404 44.5599 21.8737 44.5599 15.207 44.5599C14.6793 44.5735 14.153 44.5002 13.649 44.3429C13.184 44.1869 13.158 44.0919 13.502 43.7429C15.2954 41.9429 17.0904 40.1429 18.887 38.3429C21.7644 35.4569 24.641 32.5699 27.517 29.6819C27.987 29.2099 27.991 29.2109 28.45 29.6699C29.6134 30.8346 30.7764 32.0012 31.939 33.1699C32.3602 33.6336 32.8739 34.004 33.4468 34.2573C34.0198 34.5106 34.6394 34.6412 35.2659 34.6406C35.8923 34.64 36.5117 34.5083 37.0842 34.254C37.6567 33.9997 38.1697 33.6284 38.59 33.1639C39.767 31.9899 40.949 30.8209 42.106 29.6279C42.422 29.3019 42.619 29.2849 42.95 29.6179C47.624 34.3239 52.305 39.0239 56.993 43.7179C57.384 44.1109 57.36 44.1839 56.82 44.3589C56.3453 44.5025 55.8509 44.57 55.355 44.5589C48.6384 44.5569 41.9224 44.5573 35.207 44.5599Z",
    fill: "#FCEFEA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1480_11889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.852 27.275C59.852 31.5717 59.852 35.8679 59.852 40.1639C59.8594 40.6917 59.765 41.216 59.574 41.708C59.4 42.146 59.333 42.165 58.991 41.823C57.891 40.723 56.808 39.6229 55.713 38.5229C52.135 34.9376 48.5564 31.3533 44.977 27.77C44.469 27.262 44.469 27.261 44.96 26.77L58.837 12.854C59.375 12.315 59.42 12.3309 59.662 13.0649C59.7956 13.4919 59.8591 13.9377 59.85 14.385C59.8494 18.6823 59.85 22.979 59.852 27.275Z",
    fill: "#FCEFEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1480_11889",
    x: 3.26929,
    y: 0.00292969,
    width: 63.9912,
    height: 41.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_11889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_11889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1480_11889",
    x: 0.692993,
    y: 2.47827,
    width: 35.2321,
    height: 49.5858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_11889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_11889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1480_11889",
    x: 3.26868,
    y: 19.3268,
    width: 63.9908,
    height: 35.2347,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_11889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_11889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1480_11889",
    x: 34.5939,
    y: 2.47827,
    width: 35.2585,
    height: 49.5819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_11889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_11889",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.ab6d2eb0250b09e8e0f03d2aea599a4e.svg";
export { ForwardRef as ReactComponent };